// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1aJI8","wrap":"Layout_wrap__vzikw","content":"Layout_content__3RUoh"};